import { useCallback } from "react";
import { useGoogleReCaptcha } from "react-google-recaptcha-v3";

/**
 * Returns a reCAPTCHA token resolver for the given action, ready to be injected
 * into a form's `getRecaptchaToken` prop. Fail open: a captcha outage — or a
 * tree without the provider (dev/prelive) — must not block real leads, so it
 * resolves to `undefined` and the backend decides how to treat a missing token.
 */
export const useRecaptchaToken = (action: string) => {
    const { executeRecaptcha } = useGoogleReCaptcha();

    return useCallback(async (): Promise<string | undefined> => {
        try {
            return await executeRecaptcha?.(action);
        } catch (error) {
            // eslint-disable-next-line no-console
            console.error("Failed to resolve reCAPTCHA token:", error);
            return undefined;
        }
    }, [executeRecaptcha, action]);
};
